import { PartialTheme } from '@elastic/charts';
import { MAIN } from 'theme';

export const customTheme: PartialTheme = {
  axes: {
    axisLine: {
      stroke: MAIN.SECONDARY,
    },
    tickLabel: {
      fontSize: 12,
      fontFamily:
        "'Inter UI', -apple-system, BlinkMacSystemFont,\n  'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
      fill: MAIN.GREY_7,
    },
    tickLine: {
      visible: true,
      stroke: MAIN.GREY_7,
      strokeWidth: 1,
    },
  },
  crosshair: {
    band: {
      fill: 'none',
    },
  },
  legend: {
    horizontalHeight: 1,
    margin: 1,
  },
  barSeriesStyle: {
    rectBorder: {
      stroke: MAIN.PRIMARY,
      visible: true,
      strokeWidth: 5,
    },
    rect: {
      fill: MAIN.PRIMARY,
      opacity: 0.5,
      widthRatio: 1.5,
      widthPixel: 20,
    },
  },
};
